export const CONSULTING_FORM_ID = 'consultingOfferForm'
